import script from "./DetailSupplierMaster.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailSupplierMaster.vue?vue&type=script&setup=true&lang=js"

import "./DetailSupplierMaster.vue?vue&type=style&index=0&id=5d5e3576&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d5e3576"]])

export default __exports__